import Equal from "./Equal";


let NotEqual = Equal.extend("NotEqual", {
    literal: ["<>", "!="],

    compile2js(left, right) {
        right = JSON.stringify(right);
        return left + " != " + right;
    }
});

export default NotEqual;
